import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/page/login'

Vue.use(Router)

 const VueRouter=new Router({
  //mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
    	path: '/list_rank',
    	component: () => import('../components/page/phone/list_rank'),
    	meta: { title: '排播首页-手机' },
    	name:'list_rank',
    	props: { type: 'my' }
    },
    {
    	path: '/list_rank_c',
    	component: () => import('../components/page/phone/list_rank_c'),
    	meta: { title: '排播首页-手机-内页' },
    	name:'list_rank_c',
    	props: { type: 'my' }
    },
    {
      path: '/',
      name: 'index',
      redirect: '/index/tongji'
    },
    {
      path: '/index',
      name: '/',
      component: () => import('../components/page/index.vue'),
      meta: {
          requiresAuth: true   // 要求验证的页面,在此情况下其子页面也会被验证.
         },
      children: [
      	{
      		path: 'tongji',
      		component: () => import('../components/page/index/tongji.vue'),
      		meta: { title: '首页统计' },
      		props: { type: 'my' }
      	},
        {
        	path: 'tuijian',
        	component: () => import('../components/page/index/tuijian.vue'),
        	meta: { title: '首页推荐' },
        	props: { type: 'my' }
        },
        {
        	path: 'add_tuijian',
        	component: () => import('../components/page/index/add_tuijian.vue'),
        	meta: { title: '添加推荐' },
        	props: { type: 'my' }
        },
        {
        	path: 'mokuai',
        	component: () => import('../components/page/index/mokuai.vue'),
        	meta: { title: '模块管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'add_mokuai',
        	component: () => import('../components/page/index/add_mokuai.vue'),
        	meta: { title: '添加模块' },
        	props: { type: 'my' }
        },
        {
        	path: 'pifu',
        	component: () => import('../components/page/index/pifu'),
        	meta: { title: '主屏皮肤管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'mei_pic',
        	component: () => import('../components/page/media/mei_pic'),
        	meta: { title: '图片管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'add_mei_pic',
        	component: () => import('../components/page/media/add_mei_pic'),
        	meta: { title: '添加图片' },
        	props: { type: 'my' }
        },
        {
        	path: 'media_mod',
        	component: () => import('../components/page/media/mod_mei_pic'),
        	meta: { title: '修改图片' },
          name:'mod_mei_pic',
        	props: { type: 'my' }
        },
        {
        	path: 'mei_video',
        	component: () => import('../components/page/media/mei_video'),
        	meta: { title: '视频管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'add_mei_video',
        	component: () => import('../components/page/media/add_mei_video'),
        	meta: { title: '添加视频' },
        	props: { type: 'my' }
        },
        {
        	path: 'mod_mei_video',
        	component: () => import('../components/page/media/mod_mei_video'),
        	meta: { title: '修改视频' },
          name:'mod_mei_video',
        	props: { type: 'my' }
        },
        {
        	path: 'mei_doc',
        	component: () => import('../components/page/media/mei_doc'),
        	meta: { title: '文档管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'add_mei_doc',
        	component: () => import('../components/page/media/add_mei_doc'),
        	meta: { title: '添加文档' },
        	props: { type: 'my' }
        },
        {
        	path: 'mod_mei_doc',
        	component: () => import('../components/page/media/mod_mei_doc'),
        	meta: { title: '修改文档' },
          name:'mod_mei_doc',
        	props: { type: 'my' }
        },
        {
        	path: 'mei_list',
        	component: () => import('../components/page/media/mei_list'),
        	meta: { title: '分类管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'user',
        	component: () => import('../components/page/user/user_li'),
        	meta: { title: '用户管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'add_user',
        	component: () => import('../components/page/user/add_user'),
        	meta: { title: '添加用户' },
        	props: { type: 'my' }
        },
        {
        	path: 'setting',
        	component: () => import('../components/page/user/setting'),
        	meta: { title: '个人设置' },
        	props: { type: 'my' }
        },
        {
        	path: 'mod_user',
        	component: () => import('../components/page/user/mod_user'),
        	meta: { title: '编辑用户' },
          name: 'mod_user',
        	props: { type: 'my' }
        },
        {
        	path: 'versions',
        	component: () => import('../components/page/user/versions'),
        	meta: { title: '版本管理' },
          name: 'versions',
        	props: { type: 'my' }
        },
        {
        	path: 'add_versions',
        	component: () => import('../components/page/user/add_versions'),
        	meta: { title: '添加版本' },
          name: 'add_versions',
        	props: { type: 'my' }
        },
        {
        	path: 'power',
        	component: () => import('../components/page/power/power_li'),
        	meta: { title: '开关机管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'power_add',
        	component: () => import('../components/page/power/add_power_li'),
        	meta: { title: '添加定时' },
        	props: { type: 'my' }
        },
        {
        	path: 'power_mod',
        	component: () => import('../components/page/power/mod_power_li'),
        	meta: { title: '修改定时' },
          name:'mod_power',
        	props: { type: 'my' }
        },
        {
        	path: 'group',
        	component: () => import('../components/page/group/group_li'),
        	meta: { title: '终端分组管理' },
        	props: { type: 'my' }
        },
        {
        	path: 'group_add',
        	component: () => import('../components/page/group/add_group_li'),
        	meta: { title: '添加分组' },
        	props: { type: 'my' }
        },
        {
        	path: 'group_mod',
        	component: () => import('../components/page/group/mod_group_li'),
        	meta: { title: '修改分组' },
          name:'mod_group_li',
        	props: { type: 'my' }
        },
        {
        	path: 'device',
        	component: () => import('../components/page/device/device_li'),
        	meta: { title: '终端' },
        	props: { type: 'my' }
        },
        {
        	path: 'device_add',
        	component: () => import('../components/page/device/add_device_li'),
        	meta: { title: '添加终端' },
        	props: { type: 'my' }
        },
        {
        	path: 'device_mod',
        	component: () => import('../components/page/device/mod_device_li'),
        	meta: { title: '添加终端' },
          name:'device_mod',
        	props: { type: 'my' }
        },
        {
        	path: 'rank',
        	component: () => import('../components/page/rank/rank_li'),
        	meta: { title: '排播管理' },
        	props: { type: 'my'}
        },
        {
        	path: 'rank_add',
        	component: () => import('../components/page/rank/add_rank_li'),
        	meta: { title: ' 新建排播' },
        	props: { type: 'my' }
        },
        {
        	path: 'rank_mod',
        	component: () => import('../components/page/rank/mod_rank_li'),
        	meta: { title: '更换媒资' },
          name:'mod_rank',
        	props: { type: 'my' }
        },
        {
        	path: 'mod_rank_tex',
        	component: () => import('../components/page/rank/mod_rank_tex'),
        	meta: { title: '修改排播' },
          name:'mod_rank_tex',
        	props: { type: 'my' }
        },
        {
        	path: 'rank_select',
        	component: () => import('../components/page/rank/rank_select'),
        	meta: { title: '操作点播' },
          name:'rank_select',
        	props: { type: 'my' }
        },
        {
        	path: 'review_media',
        	component: () => import('../components/page/review/review_media_li'),
        	meta: { title: '媒资审核' },
        	props: { type: 'my' }
        },
        {
        	path: 'review_rank',
        	component: () => import('../components/page/review/review_rank_li'),
        	meta: { title: '排播审核' },
          name:'review_rank',
        	props: { type: 'my' }
        },
        {
        	path: 'review_rank_n',
        	component: () => import('../components/page/review/review_rank_n'),
        	meta: { title: '排播审核内页' },
          name:'review_rank_n',
        	props: { type: 'my' }
        },
        {
        	path: 'mod_zhibo',
        	component: () => import('../components/page/rank/mod_zhibo'),
        	meta: { title: '直播编辑' },
          name:'mod_zhibo',
        	props: { type: 'my' }
        },
        {
        	path: 'moban_li',
        	component: () => import('../components/page/moban/moban_li'),
        	meta: { title: '模版列表' },
          name:'moban_li'
        },
        {
        	path: 'moban_add_a',
        	component: () => import('../components/page/moban/add_moban_a'),
        	meta: { title: '添加模板' },
          name:'add_moban_a'
        },
        {
        	path: 'moban_add_b',
        	component: () => import('../components/page/moban/add_moban_b'),
        	meta: { title: '添加模板媒资' },
          name:'add_moban_b'
        },
        {
        	path: 'mod_moban_a',
        	component: () => import('../components/page/moban/mod_moban_a'),
        	meta: { title: '编辑模板第一步' },
          name:'mod_moban_a'
        },
        {
        	path: 'moban_view',
        	component: () => import('../components/page/moban/moban_view'),
        	meta: { title: '模版详细' },
          name:'moban_view'
        },
        {
        	path: 'moban_type',
        	component: () => import('../components/page/moban/moban_list'),
        	meta: { title: '模版分类' },
          name:'moban_list'
        },
        {
        	path: '*',
        	component: () => import('../components/page/other/404'),
        	meta: { title: '404' }
        },
      ]
    },
    {
    	path: '*',
    	component: () => import('../components/page/other/404'),
    	meta: { title: '404' }
    }
  ]
})

VueRouter.beforeEach((to, from, next) => {
   let access_token=sessionStorage.getItem("token");
   console.log('sd======',to)
   if(access_token===null){
     if(to.path=='/login' || to.path=='/list_rank' || to.path=='/list_rank_c'){
       next();
     }else{
       next('/login');
     }
   }else if(access_token==''){
    next();
   }else{
     //console.log('3')
      next();
   }

});

export default VueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js